<template>
  <v-container fluid class="pa-0 ma-8">
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="settings"
      :sort-by="[{ key: 'name', order: 'asc' }]"
      class="elevation-3 rounded-lg"
    >
      <template v-slot:no-data>
        <h3>No data available</h3>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>الإعدادات</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <DialogSetting
            :item="item"
            :saveFunction="save"
            mode="edit"
            iconName="mdi-pencil"
          />
        </v-row>
      </template>
      <template v-slot:[`item._key`]="{ item }">
        <v-container>
          <p>{{ $t(`${item._key}`) }}</p>
        </v-container>
      </template>
      <template v-slot:[`item._type`]="{ item }">
        <v-container>
          <p>{{ $t(`${item._type}`) }}</p>
        </v-container>
      </template>
      <template v-slot:[`item._value`]="{ item }">
        <v-container>
          <p>{{ calcValue(item) }}</p>
        </v-container>
      </template>
    </v-data-table>
  </v-container>
  <overlay-loader v-model="loading" />
</template>
<script>
import DialogSetting from "@/components/dialogs/DialogSetting.vue";

import repo from "@/store/repo.js";
import swalFun from "@/plugins/swalFun";
import OverlayLoader from "@/components/common/OverlayLoader.vue";

export default {
  components: {
    DialogSetting,
    OverlayLoader,
  },
  data: () => ({
    loading: false,
    headers: [
      { title: "الإعداد", key: "_key" },
      { title: "القيمة", key: "_value" },
      { title: "النوع", key: "_type" },
      { title: "العمليات", key: "actions" },
    ],
    dialog: false,
    dialogSimp: false,
    editedIndex: -1,
    messages: {
      delete: "هل أنت متأكد",
    },
  }),
  computed: {
    settings() {
      let us = repo.settings.getAllSettings();
      return us;
    },
  },
  methods: {
    calcValue(item) {
      const days = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
      ];
      if (item._key == "cut_day" || item._key == "pay_day") {
        return this.$t(days[parseInt(item._value) - 1]);
      }
      return item._value;
    },
    async fetch() {
      this.loading = true;
      const res = await repo.settings.fetchAll();
      if (res) {
        //swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
      this.loading = false;
    },
    async save(formData, mode) {
      if (mode == "edit") {
        //update a setting
        //console.log("form", mode, formData);
        const res = await repo.settings.update(formData);
        if (res) {
          swalFun.success("success");
        } else {
          swalFun.fail("error");
        }
      }
    },
  },
  async mounted() {
    await this.fetch();
  },
};
</script>
